import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DataTablesResponse } from '../models/datatables';
import { AdvExpenseDashBoard, SelectListParams, AdvExpenseFilters, StihlAdvExpenseDTO, AdvExpenseStatistics, AdvExpenseBudgetResult, AdvExpensSendAlert } from '../models/stihl-adv-expense-dto';
import { Select2Data } from 'ng-select2-component';
import { StihlStatisticsFilter } from '../models/stihl-statistics-dto';


@Injectable({
  providedIn: 'root'
})

export class AdvExpenseService {

  private pathAPI = environment.urlAPI;
  private controller = "StihlAdvExpense/";

  constructor(private http: HttpClient) { }

  //#region CRUD

  public Get(id: string): Observable<StihlAdvExpenseDTO> {
    return this.http.get<StihlAdvExpenseDTO>(this.pathAPI + this.controller + id);
  }

  public Put(id: string, data: FormData): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + id, data);
  }

  public PutInvoiceAmount(id: string, percentage: number): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'PutStihlAdvExpenseInvoiceAmount/' + id + '/' + percentage, null);
  }

  public PutBudgetYear(id: string, year: number): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'PutStihlAdvExpenseBudgetYear/' + id + '/' + year, null);
  }

  public Post(data: FormData): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller, data);
  }

  public PostLog(data: any): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller + 'PostLog', data);
  }

  public ChangeStatus(id: string, idStatus: number): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'ChangeStatus/' + id + '/' + idStatus, null);
  }

  //#endregion

  public GetDatatable(data: any, filter: string): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDatatable/' + filter, data);
  }

  public GetDistrictManagerDashboard(): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + 'GetStihlDistrictManagerDashboard');
  }

  public GetDistrictDashboard(data: SelectListParams): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller + 'GetStihlDistrictDashboard', data);
  }

  public GetDistributorDashboard(data: SelectListParams): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller + 'GetDistributorDashboard', data);
  }

  public GetCampaignTypeDashboard(data: SelectListParams): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller + 'GetCampaignTypeDashboard', data);
  }

  public GetMediaDashboard(data: SelectListParams): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller + 'GetMediaDashboard', data);
  }

  public GetFormatDashboard(data: SelectListParams): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller + 'GetFormatDashboard', data);
  }

  public GetSupportDashboard(data: SelectListParams): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller + 'GetSupportDashboard', data);
  }

  public GetStatusDashboard(): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + 'GetStatusDashboard');
  }

  public getAdvExpenseYears(): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + 'GetAdvExpenseYears');
  }

  public GetDashboard(data: AdvExpenseFilters): Observable<AdvExpenseDashBoard> {
    return this.http.post<AdvExpenseDashBoard>(this.pathAPI + this.controller + 'GetDashboard', data);
  }

  public changeStatus(id: string, idStatus: number): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'ChangeStatus/' + id + '/' + idStatus, null);
  }

  //#region SELECT-LISTS

  public GetCampaignType(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetCampaignType');
  }

  public GetMedia(idCampaignType: string): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetMedia/' + idCampaignType);
  }

  public GetFormat(idMedia: string): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetFormat/' + idMedia);
  }

  public GetSupport(idMedia: string): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetSupport/' + idMedia);
  }

  public GetCreativePieceType(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetCreativePieceType');
  }

  public GetCampaign(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetCampaign');
  }

  //#region EXCEL

  DownloadExcel(filter): Observable<Blob> {
    let requestOptions: Object = {
      responseType: 'blob'
    }
    let endpoint = this.pathAPI + this.controller + 'GetFileExcel';
    return this.http.post<Blob>(endpoint, filter, requestOptions);
  }

  //#endregion

  public GetDistrictManager(): Observable<boolean> {

    return this.http.get<boolean>(this.pathAPI + this.controller + 'GetStihlDistrictManager/');
  }

  public GetStatistics(filter: StihlStatisticsFilter): Observable<AdvExpenseStatistics[]> {

    return this.http.post<AdvExpenseStatistics[]>(this.pathAPI + this.controller + 'GetStatistics', filter);
  }

  //#region BUDGET

  public LoadAdvExpenseBudget(fileToUpload: File, year: number): Observable<any> {
    let formData: FormData = new FormData();
    formData.append('fileKey', fileToUpload, fileToUpload.name);
    return this.http.post<any>(this.pathAPI + 'StihlAdvExpenseAdmin/LoadAdvExpenseBudget/' + year, formData);
  }

  public GetBudgetData(data: any): Observable<AdvExpenseBudgetResult> {
    return this.http.post<AdvExpenseBudgetResult>(this.pathAPI + 'StihlAdvExpense/GetBudgetData', data);
  }

  public SendBudgetAlert(model: AdvExpensSendAlert): Observable<any> {
    return this.http.post<any>(this.pathAPI + 'StihlAdvExpense/SendBudgetAlert/', model);
  }

  public GetBudgetAlertLevel(idUser): Observable<number> {
    return this.http.get<number>(this.pathAPI + 'StihlAdvExpense/GetBudgetAlertLevel/' + idUser);
  }

  public SendMailLoadBudget(): Observable<any> {
    return this.http.post<any>(this.pathAPI + 'StihlAdvExpenseAdmin/SendMailLoadBudget/', null);
  }

  GetMontlyExcel(year): Observable<Blob> {
    let requestOptions: Object = {
      responseType: 'blob'
    }
    let endpoint = this.pathAPI + 'StihlAdvExpense/GetMontlyExcel/' + year;
    return this.http.post<Blob>(endpoint, null, requestOptions);
  }


  public GetBudgetYears(): Observable<Array<any>> {
    return this.http.get<Array<any>>(this.pathAPI + 'StihlAdvExpense/GetBudgetYears');
  }

  //#endregion
}
